// extracted by mini-css-extract-plugin
export default {"label":"Select_label__0naC5","select":"Select_select__X0zVd","selectWrapper":"Select_selectWrapper__UM0Y7"};